export const DK_AUTHORITY_URL = 'https://skat.dk/erhverv/moms'
export const DE_AUTHORITY_URL = 'https://www.elster.de/eportal/start'
export const FR_AUTHORITY_URL = 'https://www.impots.gouv.fr/accueil'
export const NL_AUTHORITY_URL = 'https://www.belastingdienst.nl/wps/wcm/connect/nl/home/home'
